import { Injectable } from "@angular/core";
import { HttpRequest, HttpResponse } from "@angular/common/http";

const maxAge = 30000;

@Injectable({
  providedIn: "root",
})
export class CacheRequestService {
  cache = new Map();

  get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.urlWithParams;
    const cached = this.cache.get(url);
    if (!cached) {
      return undefined;
    }
    const isExpired = cached.lastRead < Date.now() - maxAge;
    const expired = isExpired ? "expired " : "";
    return cached.response;
  }

  put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    const url = req.url;
    const entry = { url, response, lastRead: Date.now() };
    this.cache.set(url, entry);
    const expired = Date.now() - maxAge;
    this.cache.forEach((expiredEntry) => {
      if (expiredEntry.lastRead < expired) {
        this.cache.delete(expiredEntry.url);
      }
    });
  }

  delete(key: string): void {
    this.cache.delete(key);
    let cacheKey = key.substring(0, key.lastIndexOf("/"));
    this.cache.delete(cacheKey);
  }

  deleteRoot(key: string): void {
    this.cache.delete(key);
    let cacheKey = key.substring(0, key.lastIndexOf("/"));
    this.cache.delete(cacheKey);
    cacheKey = cacheKey.substring(0, cacheKey.lastIndexOf("/"));
    this.cache.delete(cacheKey + "/");
  }

  reset(): void {
    this.cache = new Map<any, any>();
  }
}
